import React, { useState, useEffect, useRef } from "react";
import { Upload, Button, Space, Progress, message } from "antd";
import {
  UploadOutlined,
  SearchOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import ImageSelectorModal from "./ImageSelectorModal/ImageSelectorModal";
import AwsService from "services/AwsService";
import "./index.css";

const ImageUpload = (props) => {
  const [fileList, setFileList] = useState();
  const [showProgress, setShowProgress] = useState(false);
  const [progress, setProgress] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [fileerror, setFileError] = useState(false);
  const progressRef = useRef(0);

  const { updateImage, image, showSelector, showDragger, passData } = props;

  const { Dragger } = Upload;

  const updatePercentageHandler = (percentageValue) => {
    setProgress(percentageValue);
    progressRef.current = percentageValue;
  };

  useEffect(() => {
    image &&
      setFileList([
        {
          uid: "-1",
          name: "Image",
          status: "done",
          url: image,
          thumbUrl: image,
        },
      ]);
  }, [image]);

  const handleChange = (url, searchTerm) => {
    setFileList([
      {
        uid: "-1",
        name: searchTerm ? searchTerm : "Image",
        status: "done",
        url: url,
        thumbUrl: url,
      },
    ]);

    if (passData) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          updateImage(blob); // Directly pass the Blob object
        })
        .catch((error) =>
          console.error("Error fetching and reading data:", error),
        );
    } else {
      updateImage(url); // Passes the standard URL
    }
  };

  const uploadprops = {
    accept: ".png, .jpeg, .jpg",
    onRemove: () => {
      setFileList([]);
      updateImage(null); // Optionally reset the image state
    },
    beforeUpload: (file) => {
      const extension = file.name.split(".").pop().toLowerCase();
      if (["png", "jpeg", "jpg"].includes(extension)) {
        setFileError(false);

        if (passData) {
          updateImage(file); // Passes the file Blob
        } else {
          setShowProgress(true);
          AwsService.postImage(file, updatePercentageHandler).then((res) => {
            const { url } = res;
            if (progressRef.current === 100) {
              setTimeout(() => {
                updateImage(url);
                setShowProgress(false);
              }, 1000);
            }
          });
        }
        return false; // Prevent default upload behavior
      } else {
        setFileError(true);
        message.error(`Invalid file type`);
        return Upload.LIST_IGNORE; // Continue with the upload to trigger error handling
      }
    },
    fileList,
  };

  const showImageSelectorModal = () => {
    setModalVisible(!modalVisible);
  };

  return (
    <>
      {showDragger ? (
        <Dragger {...uploadprops} showUploadList={!fileerror}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag an image to this area to upload. Supported image
            formats are PNG, JPG and JPEG.
          </p>
        </Dragger>
      ) : (
        <Space align="baseline">
          <Upload
            listType="picture"
            maxCount={1}
            className="upload-list-inline"
            {...uploadprops}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
          {showSelector && (
            <>
              <p style={{ marginLeft: fileList?.length > 0 && "-6rem" }}>or</p>
              <Button
                style={{ marginLeft: fileList?.length > 0 && "-5rem" }}
                icon={<SearchOutlined />}
                onClick={() => showImageSelectorModal()}
              >
                Search Images
              </Button>
            </>
          )}
          {modalVisible && (
            <ImageSelectorModal
              showImageSelectorModal={showImageSelectorModal}
              handleChange={handleChange}
            />
          )}
        </Space>
      )}
      {showProgress && (
        <Progress style={{ width: "25rem" }} percent={progress} />
      )}
    </>
  );
};

export default ImageUpload;
